const translations: Record<string, string> = {
  'common:siteName': 'Free PDF Tools',
  'common:nav.home': 'Home',
  'common:nav.pdfToWord': 'PDF to Word',
  'common:nav.pdfToExcel': 'PDF to Excel',
  'common:nav.pdfToPpt': 'PDF to PPT',
  'common:nav.imageConvert': 'Image Convert',
  'common:nav.pdfTools': 'PDF Tools',
  'common:nav.tutorials': 'Tutorials',
  'common:nav.faq': 'FAQ',

  'common:footer.description': 'The best free PDF tools for all your PDF conversion and editing needs. No registration required.',
  'common:footer.quickLinks': 'Quick Links',
  'common:footer.about': 'About',
  'common:footer.aboutUs': 'About Us',
  'common:footer.tutorials': 'Tutorials',
  'common:footer.faq': 'FAQ',
  'common:footer.privacyPolicy': 'Privacy Policy',
  'common:footer.subscribe': 'Newsletter',
  'common:footer.subscribeNote': 'Get the latest tips and updates.',
  'common:footer.subscribePlaceholder': 'Enter your email',
  'common:footer.subscribeButton': 'Subscribe',
  'common:footer.subscribing': 'Subscribing...',
  'common:footer.subscribeSuccess': '✓ Subscribed successfully!',
  'common:footer.subscribeFailed': 'Subscription failed, please try again.',
  'common:footer.subscribeError': 'Network error, please try again.',
  'common:footer.adSpace': 'Ad Space',
  'common:footer.copyright': '© 2024 Free PDF Tools. All rights reserved.',

  'common:features.pdfToDoc': 'PDF to Documents',
  'common:features.pdfToDocDesc': 'Convert PDF to Word, Excel, PPT and more editable formats.',
  'common:features.imageToPdf': 'Image to PDF',
  'common:features.imageToPdfDesc': 'Combine multiple images into a single PDF file easily.',
  'common:features.pdfMerge': 'Merge & Split PDF',
  'common:features.pdfMergeDesc': 'Merge multiple PDFs or split one PDF into separate files.',
  'common:features.startConvert': 'Start Converting',
  'common:features.useNow': 'Use Now',
  'common:features.mostPopular': 'Most Popular',

  'home:hero.title': 'Free Online PDF Tools',
  'home:hero.subtitle': 'Convert, edit and manage your PDF files easily. No registration required, 100% free!',
  'home:hero.free': 'Free Forever',
  'home:hero.noRegistration': 'No Sign-up',
  'home:hero.secure': 'Secure & Private',
  'home:hero.startConverting': 'Start Converting',
  'home:hero.viewAllTools': 'View All Tools',
  'home:hero.stats.users': 'Happy Users',
  'home:hero.stats.conversions': 'Files Converted',
  'home:hero.stats.rating': 'User Rating',

  'home:allTools.title': 'All PDF Tools',
  'home:allTools.subtitle': 'Everything you need to work with PDF files, completely free.',
  'home:allTools.tryNow': 'Try Now',
  'home:tools.pdfToWord.name': 'PDF to Word',
  'home:tools.pdfToWord.description': 'Convert PDF to editable Word documents.',
  'home:tools.pdfToExcel.name': 'PDF to Excel',
  'home:tools.pdfToExcel.description': 'Extract tables from PDF to Excel spreadsheets.',
  'home:tools.pdfToPpt.name': 'PDF to PPT',
  'home:tools.pdfToPpt.description': 'Transform PDF into PowerPoint presentations.',
  'home:tools.pdfToImage.name': 'PDF to Image',
  'home:tools.pdfToImage.description': 'Convert PDF pages to JPG or PNG images.',
  'home:tools.imageToPdf.name': 'Image to PDF',
  'home:tools.imageToPdf.description': 'Combine images into a single PDF file.',
  'home:tools.mergePdf.name': 'Merge PDF',
  'home:tools.mergePdf.description': 'Combine multiple PDF files into one.',
  'home:tools.splitPdf.name': 'Split PDF',
  'home:tools.splitPdf.description': 'Extract pages from a PDF file.',
  'home:tools.compressPdf.name': 'Compress PDF',
  'home:tools.compressPdf.description': 'Reduce PDF file size without quality loss.',

  'home:whyUs.title': 'Why Choose Us?',
  'home:whyUs.subtitle': 'We provide the best free PDF tools with no hidden fees or registration.',
  'home:whyUs.free.title': '100% Free',
  'home:whyUs.free.description': 'All tools are completely free. No hidden fees, no subscriptions.',
  'home:whyUs.fast.title': 'Lightning Fast',
  'home:whyUs.fast.description': 'Our servers process your files in seconds.',
  'home:whyUs.secure.title': 'Secure & Private',
  'home:whyUs.secure.description': 'Your files are deleted automatically after conversion.',
  'home:whyUs.easy.title': 'Easy to Use',
  'home:whyUs.easy.description': 'Simple drag-and-drop interface, no technical skills needed.',
  'home:whyUs.cta.title': 'Ready to Get Started?',
  'home:whyUs.cta.description': 'Join millions of users who trust our free PDF tools every day.',
  'home:whyUs.cta.button': 'Try Free Now',

  'home:testimonials.title': 'What Users Say',
  'home:testimonials.subtitle': 'Trusted by millions of users worldwide.',
  'home:testimonials.trustedBy': 'Trusted and certified by',
  'home:testimonials.badges.secure': 'SSL Secured',
  'home:testimonials.badges.verified': 'Verified Safe',
  'home:testimonials.badges.award': 'Top Rated Tool',
  'home:testimonials.user1.name': 'Sarah Johnson',
  'home:testimonials.user1.role': 'Marketing Manager',
  'home:testimonials.user1.content': 'This is the best free PDF tool I have ever used. Fast, reliable, and no annoying sign-up required!',
  'home:testimonials.user2.name': 'Emily Chen',
  'home:testimonials.user2.role': 'Freelance Designer',
  'home:testimonials.user2.content': 'I convert PDFs to Word every day for my clients. This tool saves me so much time and it\'s completely free!',
  'home:testimonials.user3.name': 'Michael Torres',
  'home:testimonials.user3.role': 'Business Analyst',
  'home:testimonials.user3.content': 'The PDF to Excel feature is incredibly accurate. It extracts tables perfectly every single time.',

  'home:ads.topBanner': 'Advertisement',
  'home:ads.middleBanner': 'Advertisement',

  'upload:dragDrop': 'Drag & Drop your PDF file here',
  'upload:or': 'or',
  'upload:selectFile': 'Select File',
  'upload:processing': 'Processing...',
  'upload:converting': 'Converting your file...',
  'upload:done': 'Done!',
  'upload:success': 'Your file has been converted successfully',
  'upload:download': 'Download File',
  'upload:convertAnother': 'Convert Another File',
  'upload:fileSize': 'Maximum file size: 10MB',
  'upload:supportedFormats': 'Supported formats',

  'upload.dragDrop': 'Drag and drop your PDF file here',
  'upload.or': 'or',
  'upload.selectFile': 'Select PDF File',
  'upload.fileSize': 'Maximum file size: 20MB',
  'upload.uploading': 'Uploading...',
  'upload.processing': 'Processing...',
  'upload.converting': 'Converting...',
  'upload.preparing': 'Preparing download...',
  'upload.done': 'Conversion Complete!',
  'upload.download': 'Download',
  'upload.convertAnother': 'Convert Another File',
  'upload.convertedTo': 'Converted to',
  'upload.error': 'Conversion Failed',
  'upload.retry': 'Retry',
  'upload.selectAnother': 'Select Another File',
  'upload.fileTooLarge': 'File size exceeds 20MB limit',
  'upload.invalidFormat': 'Invalid file format',
  'upload.networkError': 'Network error, please try again',
  'upload.conversionFailed': 'Conversion failed, please try again',
  'upload.howItWorks': 'How It Works',
  'upload.step1': 'Upload File',
  'upload.step1Desc': 'Select or drag your PDF file',
  'upload.step2': 'Convert',
  'upload.step2Desc': 'We process your file automatically',
  'upload.step3': 'Download',
  'upload.step3Desc': 'Get your converted file instantly',
  'upload.downloading': 'Preparing download...',
  'upload.progress': 'Progress: {percent}%',

  'pdfToWord:title': 'PDF to Word',
  'pdfToWord:description': 'Convert your PDF files to editable Word documents for free',
  'pdfToWord:feature1.title': 'Fast Conversion',
  'pdfToWord:feature1.desc': 'Convert PDF to Word in seconds',
  'pdfToWord:feature2.title': 'High Quality',
  'pdfToWord:feature2.desc': 'Preserve original formatting and layout',
  'pdfToWord:feature3.title': '100% Free',
  'pdfToWord:feature3.desc': 'No registration or payment required',
  'pdfToWord:howTo.title': 'How to Use',
  'pdfToWord:howTo.step1': 'Upload your PDF file',
  'pdfToWord:howTo.step2': 'Wait for conversion',
  'pdfToWord:howTo.step3': 'Download your Word file',

  'pdfToExcel:title': 'PDF to Excel',
  'pdfToExcel:description': 'Convert PDF tables to editable Excel spreadsheets',
  'pdfToExcel:feature1.title': 'Extract Tables',
  'pdfToExcel:feature1.desc': 'Extract tables from PDF automatically',
  'pdfToExcel:feature2.title': 'Accurate Data',
  'pdfToExcel:feature2.desc': 'Preserve original data structure',
  'pdfToExcel:feature3.title': 'Easy to Use',
  'pdfToExcel:feature3.desc': 'Simple and intuitive interface',
  'pdfToExcel:howTo.title': 'How to Use',
  'pdfToExcel:howTo.step1': 'Upload PDF file with tables',
  'pdfToExcel:howTo.step2': 'System will extract tables',
  'pdfToExcel:howTo.step3': 'Download your Excel file',

  'pdfToPpt:title': 'PDF to PowerPoint',
  'pdfToPpt:description': 'Transform your PDF into editable PowerPoint presentations',
  'pdfToPpt:feature1.title': 'Slide Conversion',
  'pdfToPpt:feature1.desc': 'Each PDF page becomes a PPT slide',
  'pdfToPpt:feature2.title': 'Editable',
  'pdfToPpt:feature2.desc': 'Edit text and images after conversion',
  'pdfToPpt:feature3.title': 'Secure & Private',
  'pdfToPpt:feature3.desc': 'Your files are deleted after conversion',
  'pdfToPpt:howTo.title': 'How to Use',
  'pdfToPpt:howTo.step1': 'Select your PDF file',
  'pdfToPpt:howTo.step2': 'Convert to PPT format',
  'pdfToPpt:howTo.step3': 'Download your presentation',

  'imageConvert:title': 'Image Converter',
  'imageConvert:description': 'Convert images to PDF or PDF to images easily',
  'imageConvert:feature1.title': 'Multi-Format',
  'imageConvert:feature1.desc': 'Supports JPG, PNG, BMP, GIF',
  'imageConvert:feature2.title': 'Batch Convert',
  'imageConvert:feature2.desc': 'Convert multiple images at once',
  'imageConvert:feature3.title': 'Quality Preserved',
  'imageConvert:feature3.desc': 'No image quality loss',
  'imageConvert:howTo.title': 'How to Use',
  'imageConvert:howTo.step1': 'Upload images or PDF',
  'imageConvert:howTo.step2': 'Choose output format',
  'imageConvert:howTo.step3': 'Download converted files',

  'pdfToolsPage:title': 'Complete PDF Tools',
  'pdfToolsPage:description': 'Merge, split, compress and edit your PDF files',
  'pdfToolsPage:feature1.title': 'Merge PDF',
  'pdfToolsPage:feature1.desc': 'Combine multiple PDFs into one',
  'pdfToolsPage:feature2.title': 'Split PDF',
  'pdfToolsPage:feature2.desc': 'Extract pages from PDF',
  'pdfToolsPage:feature3.title': 'Compress PDF',
  'pdfToolsPage:feature3.desc': 'Reduce PDF file size',
  'pdfToolsPage:howTo.title': 'How to Use',
  'pdfToolsPage:howTo.step1': 'Choose the tool you need',
  'pdfToolsPage:howTo.step2': 'Upload your PDF file',
  'pdfToolsPage:howTo.step3': 'Download the processed result',

  'imageConvert.pdfToImage': 'PDF to Image',
  'imageConvert.imageToPdf': 'Image to PDF',
  'imageConvert.selectImages': 'Select Images',
  'imageConvert.multipleFilesHint': 'Supports multiple images merged into one PDF',
  'imageConvert.processingFiles': 'Processing {count} files...',

  'pdfToPpt.feature1': 'Preserve Layout',
  'pdfToPpt.feature2': 'Keep Images',
  'pdfToPpt.feature3': 'Editable Presentation',
};

export default translations;
